import React from "react";
import { MiniMark } from "@/components/HeroLogo";
import { MessageCircle } from "lucide-react";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-[var(--hoa-emerald-990)] border-t border-[rgba(179,145,74,0.25)]">
    <div className="mx-auto w-full max-w-[1120px] px-5 sm:px-6 py-16 flex flex-col items-center text-center">
      <MiniMark />
      <p className="font-display text-[var(--hoa-cream-50)] text-xl mt-5">
        house of appetite
      </p>
      <p className="font-display hoa-gold-text text-base mt-2">give in.</p>
      <p className="font-label text-[9px] tracking-[0.3em] uppercase text-[rgba(240,233,216,0.5)] mt-5">
        Artisanal Home Baking&nbsp;&nbsp;•&nbsp;&nbsp;Small Batch
      </p>

      <a
        data-testid="footer-whatsapp-link"
        href="https://wa.me/919884164000"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-8 inline-flex items-center gap-2 font-label text-[11px] tracking-[0.18em] uppercase h-11 px-6 rounded-full border border-[rgba(179,145,74,0.45)] text-[var(--hoa-cream-50)] hover:bg-[rgba(240,233,216,0.06)] transition-colors"
      >
        <MessageCircle className="w-4 h-4 text-[var(--hoa-gold-400)]" strokeWidth={1.6} />
        WhatsApp the House
      </a>

      <div className="w-full border-t border-[rgba(179,145,74,0.18)] mt-12 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-center sm:text-left">
          <p className="font-label text-[9px] tracking-[0.22em] uppercase text-[rgba(240,233,216,0.4)]">
            Curated by
          </p>
          <p className="font-display text-[var(--hoa-cream-50)] text-base mt-1">
            Divya Galada
          </p>
          <p className="font-body text-[rgba(240,233,216,0.45)] text-xs mt-1 italic">
            baked with warmth of love.
          </p>
        </div>
        <div className="flex items-center gap-5">
          <p className="font-body text-[rgba(240,233,216,0.45)] text-xs">
            © {new Date().getFullYear()} house of appetite
          </p>
        </div>
      </div>
    </div>
  </footer>
);
